import { eAssociatedLendersActionType, IAssociatedLendersAction } from './AssociatedLendersAction';
import { IAssociatedLendersApplicationState } from './interface';

export const AssociatedLendersReducer = (
  oldState: IAssociatedLendersApplicationState,
  action: IAssociatedLendersAction
): IAssociatedLendersApplicationState => {
  switch (action.type) {
    case eAssociatedLendersActionType.SetAssociatedLenders:
      return {
        ...oldState,
        associatedLenders: { ...oldState.associatedLenders, [action.payload.clientId]: action.payload.lenders },
      };
    case eAssociatedLendersActionType.SetAssociatedLendersError:
      return { ...oldState, associatedLendersError: action.payload };
    case eAssociatedLendersActionType.SetAssociatedLendersFetchStatus:
      return { ...oldState, associatedLendersFetchStatus: action.payload };
    case eAssociatedLendersActionType.SetUpdateAssociatedLendersError:
      return { ...oldState, updateAssociatedLendersError: action.payload };
    case eAssociatedLendersActionType.SetUpdateAssociatedLendersFetchStatus:
      return { ...oldState, updateAssociatedLendersFetchStatus: action.payload };
  }
};
